/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogStatus from 'layout/dialog/DialogStatus';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import { useTranslation } from 'react-i18next';
import Button from 'components/common/Button';

export default function RemoveOrganizationResultDialog({ resultDialog, onToggleResultDialog, result }) {
  const { t } = useTranslation();

  const getTitle = () => {
    if (result === undefined) {
      return (
        <>
          <DialogStatus variant="success" />
          <Typography component="h3" variant="h3">
            {t('user.management.delete.organization.success.dialog.title')}
          </Typography>
        </>
      );
    }
    return (
      <>
        <DialogStatus variant="error" />
        <Typography component="h3" variant="h3">
          {t('user.management.delete.organization.error.dialog.title')}
        </Typography>
      </>
    );
  };

  const getDescription = () => {
    if (result === undefined) {
      return t('user.management.delete.organization.success.dialog.description');
    }
    return t('user.management.delete.organization.error.dialog.description');
  };

  return (
    <Dialog data-testid="invite-success-dialog" open={resultDialog.open} fullWidth maxWidth="md">
      <DialogTitle>{getTitle()}</DialogTitle>
      <DialogContent>{getDescription()}</DialogContent>
      <DialogActions>
        <Button
          data-testid="go-to-org-btn"
          onClick={() => {
            onToggleResultDialog(false);
          }}
          color="primary"
        >
          {t('button.ok.label')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
